import { browserName, browserVersion } from 'react-device-detect';

const IE_11 = 'IE11';
const isIE11: boolean = IE_11 === `${browserName}${browserVersion}`;

export default isIE11;
